import { UnaryExpression } from "./abstract.unary.expression";
import { FunctionExpression } from "./abstract.functionExpression";

export class NotContainsFunction extends FunctionExpression 
{
    constructor(field: string | UnaryExpression, value: string) 
    {
        super("not contains", field, [value]);
    }
}
